<app-modal
  [title]="'Seleccionar contacto'"
  [padding]="'md'"
  [scrollable]="true"
  [showCloseButton]="true"
  (onCloseClick)="close()"
>
    <app-contactos
      [idProspecto]="idProspecto"
      [selectionMode]="true"
      [showCreateButton]="false"
      (onSelect)="selectContacto($event)"
    />
</app-modal>
